import { useCallback, useEffect, useRef, useState } from "react";

const TIMEOUT_MS = 30 * 60 * 1000; // 30 minutos de inatividade
const WARNING_MS =  2 * 60 * 1000; // aviso 2 minutos antes

export function useSessionTimeout(onTimeout, ativo) {
    const [aviso, setAviso] = useState(false);
    const [segundosRestantes, setSegundosRestantes] = useState(WARNING_MS / 1000);

    const timerTimeout  = useRef(null);
    const timerAviso    = useRef(null);
    const timerContagem = useRef(null);
    const avisoAtivo    = useRef(false);

    const resetar = useCallback(() => {
        clearTimeout(timerTimeout.current);
        clearTimeout(timerAviso.current);
        clearInterval(timerContagem.current);
        avisoAtivo.current = false;
        setAviso(false);
        setSegundosRestantes(WARNING_MS / 1000);

        if (!ativo) return;

        timerAviso.current = setTimeout(() => {
            avisoAtivo.current = true;
            setAviso(true);
            setSegundosRestantes(WARNING_MS / 1000);
            timerContagem.current = setInterval(() => {
                setSegundosRestantes((s) => Math.max(0, s - 1));
            }, 1000);
        }, TIMEOUT_MS - WARNING_MS);

        timerTimeout.current = setTimeout(onTimeout, TIMEOUT_MS);
    }, [ativo, onTimeout]);

    useEffect(() => {
        if (!ativo) {
            clearTimeout(timerTimeout.current);
            clearTimeout(timerAviso.current);
            clearInterval(timerContagem.current);
            avisoAtivo.current = false;
            setAviso(false);
            return;
        }

        const handleAtividade = () => {
            if (!avisoAtivo.current) resetar();
        };

        const eventos = ["mousemove", "keydown", "click", "scroll", "touchstart"];
        eventos.forEach((e) => window.addEventListener(e, handleAtividade, { passive: true }));
        resetar();

        return () => {
            eventos.forEach((e) => window.removeEventListener(e, handleAtividade));
            clearTimeout(timerTimeout.current);
            clearTimeout(timerAviso.current);
            clearInterval(timerContagem.current);
        };
    }, [ativo, resetar]);

    return { aviso, segundosRestantes, resetar };
}
